export default {
  methods: {
    async onSubmitValid() {
      if (this.submit) return false;
      this.submit = true;

      this.errors.clear(this.formName);

      const r = await this.$validator.validateAll(this.formName);
      if (!r) {
        this.submit = false;
        return false;
      }

      return true;
    },
  },
}
